import React from 'react';
import { useParams } from 'react-router-dom';
import { Space } from 'antd';

import ProgramDashboardContainer from '@totem/components/services/optimize/v2/dashboard/ProgramDashboardContainer';
import ProgramDashboardPanel from '@totem/components/services/optimize/v2/dashboard/ProgramDashboardPanel';
import ProgramEditButton from '@totem/components/services/optimize/v2/dashboard/ProgramEditButton';
import ProgramImportButton from '@totem/components/services/optimize/v2/dashboard/ProgramImportButton';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ProgramDashboardPage = () => {
  const { buildingId, programId } = useParams<{
    buildingId: string;
    programId: string;
  }>();

  return (
    <ContentLayout>
      <ProgramDashboardContainer buildingId={buildingId} programId={programId}>
        <IBCard
          isCovered
          title="Optimize — Program Dashboard"
          extra={
            <Space>
              <ProgramEditButton />
              <ProgramImportButton />
            </Space>
          }
        >
          <ProgramDashboardPanel />
        </IBCard>
      </ProgramDashboardContainer>
    </ContentLayout>
  );
};

export default ProgramDashboardPage;
